import { useEffect, useState } from "react"
import Wrapper from "./style"
import services from "../../services"
import LocalStorage, { Keys } from "../../storage/LocalStorage"

export const Subscription = ({ data, setAssets, setShowMultiSubscription }) => {

    const [subs, setSubs] = useState(null)
    const [status, setStatus] = useState("Set")

    const getAssets = (e) => {
        if (subs) {
            setStatus("Loading Assets ...")
            e.target.disabled = true
            LocalStorage.set(Keys.CURRENT_SUBSCRIPTION, subs)
            services.getAssets()
                .then(({ data }) => {
                    setAssets(data.sort((a, b) => a.order - b.order))
                })
                .catch(console.log)
                .finally(() => {
                    e.target.disabled = false
                    setStatus("Set")
                    setShowMultiSubscription(false)
                })
        } else {
            setStatus("Please select subscription")
            setTimeout(() => {
                setStatus("Set")
            }, 2000)
        }
    }

    const change = e => {
        setSubs(data.find(subs => subs.subscriptionId === e.target.value));
        setStatus('Set')
    }

    useEffect(() => {
        window.document.querySelector('.subscriptionModal:not(.container)').addEventListener('click', e => {
            if (e.target.classList.contains('subscriptionModal')) {
                if (subs) {
                    setShowMultiSubscription(false)
                } else {
                    setStatus("Please select the subscription!")
                }
            }
        })
        // eslint-disable-next-line
    }, [])

    return (
        <Wrapper className="subscriptionModal">
            <section className={!status.includes('ing') ? "" : "loading"}>
                <h1>Please select subscription</h1>
                <select onChange={change}>
                    <option disabled selected value={null}>-- Select subscription --</option>
                    {
                        data.map(subs => <option key={subs.subscriptionId} value={subs.subscriptionId}>{subs.displayName}</option>)
                    }
                </select>
                <br />
                <input type="button" value={status} className="primary" onClick={getAssets} />
            </section>
        </Wrapper>
    )
}